import { useEffect, useState } from "react";
import { Spin } from "antd";
import {
  useParams,
} from "react-router-dom";
import apiFactory from "api";
import { INotification } from "constant/interfaces";
import CoveyedForm from "./form/CoveyedForm";

const EditNoti: React.FC = () => {
  const { id } = useParams();
  const [notificationDetail, setNotificationDetail] = useState<INotification>();
  const [loading, setLoading] = useState(false);
  const fetchData = async () => {
    setLoading(true);

    try {
      const res = await apiFactory.staffNoticeApi.getPostDetail(Number(id));
      setNotificationDetail(res);
    } catch (error) {
      console.error("Error fetching notification detail:", error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchData();
  }, [id]);
  return (
    <div className="bg-[#EEEEEE] px-[20px] py-[12px]">
      <div className="page-title">掲示板　親スレッド投稿</div>
      <div className="page-container">
        <Spin spinning={loading}>

        <div className="bg-white p-4">
          <div className="max-w-[490px]">
            <CoveyedForm notificationDetail={notificationDetail} isEdit />
          </div>
        </div>
      </Spin>
      </div>
    </div>
      
  );
};

export default EditNoti;
